import React from 'react';

import { RouteProps } from '../utils/Types';

const PrivateRoute = (props: RouteProps) =>
  props.isLoggedIn() ? <React.Fragment>{props.children}</React.Fragment> : null;

export default PrivateRoute;
